<p>widgetquotations works!</p>
